import {AppPageHeader} from "../../../../core/component/page-header";
import {useHistory, useRouteMatch} from 'react-router-dom';
import React, {ReactNode} from "react";

export type HeaderAccountProps = {
    createRoute?: string;
    mode?: 'list' | 'form';
    title?: string,
    subtitle?:string,
    extra?: ReactNode[]
}

export function HeaderIntegration(props: HeaderAccountProps) {
    const urlMatch = useRouteMatch();
    const history = useHistory();

    function getCreateLink(): string {
        return `${urlMatch.url}/create`;
    }

    function getListLink(): string {
        return `list`;
    }
    return (
        <>
            <AppPageHeader
                title={props.title ?? 'Integrações'}
                mode={props.mode}
                subtitle={props.subtitle ?? 'Configuração das integrações via arquivo.'}
                onCreateLink={getCreateLink()}
                onListLink={getListLink()}
                onBack={() => history.goBack()}
                extra={props.extra}
            />
        </>
    );

}
